import React, { Component } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  UnorderedList,
  ListItem,
  Divider,
  Link
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import './TermsOfService.css';

class TermsOfService extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Box bg="gray.50" minH="100vh" py={12}>
        <Container maxW="container.md">
          <Button
            leftIcon={<ArrowBackIcon />}
            variant="link"
            mb={8}
            onClick={() => this.props.onRouteChange('landing')}
            color="blue.600"
            fontSize="sm"
          >
            Terug naar home
          </Button>

          <Box bg="white" borderRadius="xl" boxShadow="lg" p={8}>
            <VStack align="stretch" spacing={10}>
            {/* Header */}
            <Box borderBottom="1px solid" borderColor="gray.300" pb={4}>
              <Heading as="h1" size="2xl" color="gray.900" mb={2} fontWeight="700">
                Algemene Voorwaarden
              </Heading>
              <Text color="gray.600" fontSize="sm">
                Laatst bijgewerkt: {new Date().toLocaleDateString('nl-NL')}
              </Text>
              <Text color="gray.600" fontSize="sm">
                Versie: 1.0
              </Text>
            </Box>

            {/* 1. Acceptance */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                1. Acceptatie van de Voorwaarden
              </Heading>
              <Text color="gray.700" lineHeight="tall">
                Door een account aan te maken en Demos te gebruiken, gaat u akkoord met deze
                algemene voorwaarden. Als u niet akkoord gaat met deze voorwaarden, mag u de dienst
                niet gebruiken.
              </Text>
            </Box>

            {/* 2. Description of Service */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                2. Beschrijving van de Dienst
              </Heading>
              <Text color="gray.700" lineHeight="tall" mb={3}>
                Demos is een platform dat inwoners en vertegenwoordigers met elkaar verbindt:
              </Text>
              <UnorderedList spacing={2} pl={6} color="gray.700">
                <ListItem>Inwoners kunnen suggesties indienen voor beleidsverbetering</ListItem>
                <ListItem>Vertegenwoordigers kunnen suggesties bekijken en hierop reageren</ListItem>
                <ListItem>AI-systemen kunnen suggesties samenvatten om trends te identificeren (alleen met uw toestemming)</ListItem>
              </UnorderedList>
            </Box>

            {/* 3. User Accounts */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                3. Gebruikersaccounts
              </Heading>
              <Text fontWeight="600" color="gray.800" mb={2}>3.1 Account Aanmaken</Text>
              <UnorderedList spacing={2} pl={6} color="gray.700" mb={4}>
                <ListItem>U moet minimaal 16 jaar oud zijn om een account aan te maken</ListItem>
                <ListItem>U moet een geldig e-mailadres en gebruikersnaam verstrekken</ListItem>
                <ListItem>U bent verantwoordelijk voor het geheimhouden van uw wachtwoord</ListItem>
                <ListItem>Eén persoon mag slechts één account hebben</ListItem>
              </UnorderedList>

              <Text fontWeight="600" color="gray.800" mb={2}>3.2 Account Verantwoordelijkheid</Text>
              <Text color="gray.700" lineHeight="tall">
                U bent verantwoordelijk voor alle activiteiten die plaatsvinden via uw account.
                Waarschuw ons onmiddellijk als u vermoedt dat uw account zonder toestemming wordt gebruikt.
              </Text>
            </Box>

            {/* 4. Acceptable Use */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                4. Acceptabel Gebruik
              </Heading>
              <Text color="gray.700" lineHeight="tall" mb={3}>
                U mag het platform NIET gebruiken voor:
              </Text>
              <UnorderedList spacing={2} pl={6} color="gray.700">
                <ListItem>Illegale activiteiten of het promoten van geweld</ListItem>
                <ListItem>Haatzaaiende, discriminerende of beledigende inhoud</ListItem>
                <ListItem>Spam, advertenties of commerciële promotie</ListItem>
                <ListItem>Het verspreiden van valse informatie</ListItem>
                <ListItem>Het schenden van de privacy van anderen</ListItem>
                <ListItem>Pogingen om het systeem te hacken of te verstoren</ListItem>
                <ListItem>Het creëren van meerdere accounts of nepaccounts</ListItem>
              </UnorderedList>
            </Box>

            {/* 5. Content Ownership */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                5. Intellectueel Eigendom
              </Heading>
              <Text fontWeight="600" color="gray.800" mb={2}>5.1 Uw Inhoud</Text>
              <Text color="gray.700" lineHeight="tall" mb={3}>
                U behoudt alle rechten op de suggesties en inhoud die u indient. Door inhoud te plaatsen
                op Demos, geeft u ons echter een licentie om:
              </Text>
              <UnorderedList spacing={2} pl={6} color="gray.700" mb={4}>
                <ListItem>Uw suggesties te tonen aan vertegenwoordigers</ListItem>
                <ListItem>De inhoud van deze suggesties te gebruiken voor AI-analyse (alleen met uw expliciete toestemming)</ListItem>
                <ListItem>Uw gebruikersnaam bij uw suggesties te tonen</ListItem>
              </UnorderedList>

              <Text fontWeight="600" color="gray.800" mb={2}>5.2 Ons Platform</Text>
              <Text color="gray.700" lineHeight="tall">
                Demos, inclusief alle code, design en functionaliteit, is eigendom van Demos
                en beschermd door auteursrecht. U mag het platform niet kopiëren, modificeren of
                reverse-engineeren.
              </Text>
            </Box>

            {/* 6. Data Processing */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                6. Gegevensverwerking
              </Heading>
              <Text color="gray.700" lineHeight="tall" mb={3}>
                Door deze voorwaarden te accepteren, stemt u in met de verwerking van uw
                persoonsgegevens zoals beschreven in ons{' '}
                <Link
                  color="blue.600"
                  textDecoration="underline"
                  onClick={() => this.props.onRouteChange('privacyPolicy')}
                  cursor="pointer"
                  fontWeight="600"
                >
                  Privacybeleid
                </Link>
                .
              </Text>
              <Text color="gray.700" lineHeight="tall">
                U kunt uw toestemming voor bepaalde verwerkingen (zoals AI-analyse) op elk moment
                intrekken via uw instellingen.
              </Text>
            </Box>

            {/* 7. Termination */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                7. Account Opzegging
              </Heading>
              <Text fontWeight="600" color="gray.800" mb={2}>7.1 Door U</Text>
              <Text color="gray.700" lineHeight="tall" mb={4}>
                U kunt uw account op elk moment verwijderen via uw instellingen. Na verwijdering
                worden uw gegevens binnen 30 dagen permanent verwijderd.
              </Text>

              <Text fontWeight="600" color="gray.800" mb={2}>7.2 Door Ons</Text>
              <Text color="gray.700" lineHeight="tall" mb={3}>
                Wij kunnen uw account opzeggen of opschorten als:
              </Text>
              <UnorderedList spacing={2} pl={6} color="gray.700">
                <ListItem>U deze voorwaarden schendt</ListItem>
                <ListItem>U illegale activiteiten uitvoert</ListItem>
                <ListItem>Uw account inactief is voor meer dan 2 jaar</ListItem>
                <ListItem>Wij verplicht worden door wet- of regelgeving</ListItem>
              </UnorderedList>
            </Box>

            {/* 8. Disclaimers */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                8. Vrijwaringen
              </Heading>
              <UnorderedList spacing={2} pl={6} color="gray.700">
                <ListItem>
                  De dienst wordt "as-is" aangeboden zonder garanties van welke aard dan ook
                </ListItem>
                <ListItem>
                  Wij garanderen niet dat de dienst ononderbroken of foutloos zal werken
                </ListItem>
                <ListItem>
                  Wij zijn niet verantwoordelijk voor inhoud die door gebruikers wordt geplaatst
                </ListItem>
                <ListItem>
                  AI-gegenereerde samenvattingen kunnen onnauwkeurigheden bevatten
                </ListItem>
              </UnorderedList>
            </Box>

            {/* 9. Limitation of Liability */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                9. Aansprakelijkheid
              </Heading>
              <Text color="gray.700" lineHeight="tall">
                Demos is niet aansprakelijk voor indirecte, incidentele of gevolgschade
                voortvloeiend uit het gebruik van het platform. Onze totale aansprakelijkheid
                is in alle gevallen beperkt tot €100.
              </Text>
            </Box>

            {/* 10. Changes to Terms */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                10. Wijzigingen in de Voorwaarden
              </Heading>
              <Text color="gray.700" lineHeight="tall">
                Wij kunnen deze voorwaarden van tijd tot tijd wijzigen. Bij belangrijke wijzigingen
                sturen wij u een e-mail. Door het platform te blijven gebruiken na wijzigingen,
                accepteert u de nieuwe voorwaarden.
              </Text>
            </Box>

            {/* 11. Governing Law */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                11. Toepasselijk Recht
              </Heading>
              <Text color="gray.700" lineHeight="tall">
                Deze voorwaarden worden beheerst door Nederlands recht. Geschillen worden voorgelegd
                aan de bevoegde rechter in Nederland.
              </Text>
            </Box>

            {/* 12. Contact */}
            <Box>
              <Heading as="h2" size="lg" color="gray.900" mb={4} fontWeight="600">
                12. Contact
              </Heading>
              <Text color="gray.700" lineHeight="tall" mb={3}>
                Voor vragen over deze voorwaarden kunt u contact met ons opnemen:
              </Text>
              <Box pl={4} borderLeft="3px solid" borderColor="blue.400">
                <Text fontWeight="600">Demos</Text>
                <Text fontSize="sm" color="gray.700">
                  E-mail juridisch: <Link href="mailto:legal@metdemos.app" color="blue.600" textDecoration="underline">legal@metdemos.app</Link>
                </Text>
                <Text fontSize="sm" color="gray.700">
                  Privacy vragen: <Link href="mailto:privacy@metdemos.app" color="blue.600" textDecoration="underline">privacy@metdemos.app</Link>
                </Text>
                <Text fontSize="sm" color="gray.700">
                  Algemene vragen: <Link href="mailto:info@metdemos.app" color="blue.600" textDecoration="underline">info@metdemos.app</Link>
                </Text>
                <Text fontSize="sm" color="gray.700" mt={3} fontWeight="500">
                  Klachten over privacy:
                </Text>
                <Text fontSize="sm" color="gray.700">
                  U kunt een klacht indienen bij de Autoriteit Persoonsgegevens via{' '}
                  <Link
                    href="https://autoriteitpersoonsgegevens.nl/nl/zelf-doen/gebruik-uw-privacyrechten/klacht-melden-bij-de-ap"
                    color="blue.600"
                    textDecoration="underline"
                    isExternal
                  >
                    autoriteitpersoonsgegevens.nl
                  </Link>
                </Text>
              </Box>
            </Box>

            <Divider />

            {/* Back button */}
            <Box textAlign="center" pt={4}>
              <Button
                leftIcon={<ArrowBackIcon />}
                colorScheme="blue"
                onClick={() => this.props.onRouteChange('landing')}
                size="lg"
              >
                Terug naar home
              </Button>
            </Box>
          </VStack>
          </Box>
        </Container>
      </Box>
    );
  }
}

export default TermsOfService;
